module.exports = __webpack_public_path__ + "img/man_bg.25271004.jpg";